




































































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
// 定数ファイル
import { Constants } from '../../CommonUtils/fixed/Constants';
import { UketsukeConstants } from '../fixed/UketsukeConstants';
import { UketsukeScreenName } from '../fixed/UketsukeScreenName';
import { Message } from '../../CommonUtils/fixed/Message';
import { ScreenMode } from '../../CommonUtils/fixed/ScreenMode';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
// 共通モジュール
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { routingControlModule } from '@/store/modules/RoutingControl';
import { applicationFormModule } from '../store/modules/ApplicationForm';
import { partialInfoModule } from '../store/modules/PartialInfo';

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class ActualPerformance extends ApiAccessBase {

  private isReadMode: boolean = true;

  // 共通パス
  private APP_PATH = Constants.UKETSUKE_URL + '/actualPerformance/' + applicationFormModule.GET_APP_TYPE;

  private created() {
    this.screenTitle = '実績高整理表';

    //20220304 要望対応 コンサルのみ文言追加 add start
    if (applicationFormModule.GET_APP_TYPE === UketsukeConstants.APP_FORM_CONSUL) {
      this.screenRemarks = '各業種について申請する部門（区分（レベル２））を登録してください。登録した部門（区分（レベル２））が当該業種を申請した団体の申請部門となります。　　　　　　　　      　部門（区分（レベル２））別に実績高を入力してください。申請しない部門（区分（レベル２））の実績は各業種（区分（レベル１））のその他欄に入力してください。申請しない業種（区分（レベル１））およびその他の事業の売上高は総合計の上のその他欄に入力してください。総合計は各事業年度の売上高と一致させてください。';
    }
    //20220304 要望対応 コンサルのみ文言追加 add end

    // モジュールに現在の画面を記録
    routingControlModule.registCurrent(this.$route.name);

    let path = this.APP_PATH;
    path = path + '/get/' + supervisingModule.GET_MODE; //画面モード
    path = path + '/' + applicationFormModule.GET_TRADER_ID;
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        // 使用する可変項目の設定（全て）
        this.setAllVariablecolsState();
        this.isReadMode = supervisingModule.IS_MODE_READ;
      }
    });
  }
  /**
   * 登録
   */
  private regist() {
    // form成形
    this.moldingSendForm(this.$refs.form);
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    let path = this.APP_PATH;
    path = path + '/update/' + applicationFormModule.GET_TRADER_ID;
    // 先頭へジャンプ
    this.hrefElement('pi-const', -50);
    this.apiAccess(path, Constants.API_METHOD_POST, false, null)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        //再検索前に登録成功メッセージ保持
        const successMessage = this.infoMessage;
        //自動計算結果取得用に再表示
        path = this.APP_PATH;
        path = path + '/get/' + supervisingModule.GET_MODE; //画面モード
        path = path + '/' + applicationFormModule.GET_TRADER_ID;
        // APIアクセス
        this.apiAccess(path, Constants.API_METHOD_GET, false, false);
        //再表示後に登録成功メッセージ格納
        this.infoMessage = successMessage;
      }
    });
  }

  /**
   * 戻る
   */
  private returnPrevious() {
    if (!this.isReadMode) {
      if (!confirm(Message.I0014)) {
        return;
      }
    }
    router.push({name: UketsukeScreenName.APPLICATION_FORM});
  }
}
